(function () {
  document.querySelectorAll('[data-cycle-to-work]').forEach(function (root) {
    var dialog = root.querySelector('[data-gci-dialog]');
    var openBtn = root.querySelector('[data-gci-open]');
    var iframe = root.querySelector('[data-gci-iframe]');
    if (!dialog || !openBtn) return;

    var iframeSrc = iframe && iframe.getAttribute('data-src');

    function openDialog() {
      if (iframe && iframeSrc && !iframe.getAttribute('src')) {
        iframe.setAttribute('src', iframeSrc);
      }
      dialog.showModal();
    }

    function closeDialog() {
      dialog.close();
    }

    openBtn.addEventListener('click', openDialog);

    dialog.querySelectorAll('[data-gci-close]').forEach(function (btn) {
      btn.addEventListener('click', closeDialog);
    });

    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) closeDialog();
    });

    dialog.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDialog();
    });
  });
})();
